import { DateTimeFormatter, Instant, LocalDate, LocalDateTime, ZoneId } from "js-joda";
import moment from "moment";

const dateFormatter = DateTimeFormatter.ofPattern("d.MM.yyyy");

const dateTimeFormatter = DateTimeFormatter.ofPattern("d.MM.yyyy HH:mm");

const dateTimeShortFormatter = DateTimeFormatter.ofPattern("d.MM. HH:mm");


const dateTimeFormatterSS = DateTimeFormatter.ofPattern("d.MM.yyyy HH:mm:ss");

export function localDateFromApi(apiValue, zoneId = ZoneId.UTC) {
  const instant = instantFromApi(apiValue);
  if (instant) {
    return LocalDate.ofInstant(instant, zoneId);
  }
}

export function localDateTimeFromApi(apiValue, zoneId = ZoneId.UTC) {
  const instant = instantFromApi(apiValue);
  if (instant) {
    return LocalDateTime.ofInstant(instant, zoneId);
  }
}

export function instantFromApi(apiValue) {
  if (apiValue !== null && typeof apiValue !== "undefined") {
    if (typeof apiValue === "object") {
      return Instant.ofEpochSecond(apiValue.epochSecond, apiValue.nano);
    } else if (typeof apiValue === "number") {
      return Instant.ofEpochMilli(apiValue * 1000);
    }
  }
}

export function momentFromApi(apiValue) {
  if (apiValue !== null && typeof apiValue !== "undefined") {
    if (typeof apiValue === "object") {
      return moment.unix(apiValue.epochSecond);
    } else if (typeof apiValue === "number") {
      return moment.unix(apiValue);
    }
  }
}

export function formatDateFromApi(apiValue, zoneId = ZoneId.UTC) {
  const localDateTime = localDateTimeFromApi(apiValue, zoneId);
  if (localDateTime) {
    return dateFormatter.format(localDateTime);
  }
}

export function formatShortDateTimeFromApi(apiValue, zoneId = ZoneId.UTC) {
  const localDateTime = localDateTimeFromApi(apiValue, zoneId);
  if (localDateTime) {
    return dateTimeShortFormatter.format(localDateTime);
  }
}

export function formatDateTimeFromApi(apiValue, zoneId = ZoneId.UTC) {
  const localDateTime = localDateTimeFromApi(apiValue, zoneId);
  if (localDateTime) {
    return dateTimeFormatter.format(localDateTime);
  }
}

export function formatDateTimeSSFromApi(apiValue, zoneId = ZoneId.UTC) {
  const localDateTime = localDateTimeFromApi(apiValue, zoneId);
  if (localDateTime) {
    return dateTimeFormatterSS.format(localDateTime);
  }
}



// WEBPACK FOOTER //
// ./src/utils/dateTime.js